import React, { CSSProperties, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  bannerContainerStyle,
  bannerIconWrapperStyle,
  textContainerStyle
} from '@/components/Profile/Content/GetMore/Banner/styles.ts';
import QuestionMarkShape from '@/components/common/svg/shapes/QuestionMarkShape.tsx';
import LightShape from '@/components/common/svg/shapes/LightShape.tsx';
import Modal from '@/animations/Modal.tsx';
import HelpCenterRecommendationsModal from '@/components/Profile/Content/MySpace/Modal/HelpCenterRecommendationsModal.tsx';

const MySpace: React.FC = () => {
  const { t } = useTranslation();

  const [helpCenterOpen, setHelpCenterOpen] = useState(false);

  const closeHelpCenter = () => setHelpCenterOpen(false);
  const openHelpCenter = () => setHelpCenterOpen(true);

  return (
    <>
      <div style={containerStyle} onClick={openHelpCenter}>
        <BannerItem
          icon={<QuestionMarkShape width={29} height={29} />}
          title={t('profile.my_space.help_center.title')}
          subtitle={t('profile.my_space.help_center.subtitle')}
        />
      </div>
      <div style={{ ...containerStyle, marginTop: 15 }}>
        <BannerItem
          icon={<LightShape width={22} height={22} />}
          title={t('profile.my_space.what_works.title')}
          subtitle={t('profile.my_space.what_works.subtitle')}
          badge="Coming Soon"
        />
      </div>
      <Modal open={helpCenterOpen} handleClose={closeHelpCenter}>
        <HelpCenterRecommendationsModal handleClose={closeHelpCenter} />
      </Modal>
    </>
  );
};

interface BannerItemProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  badge?: string;
}

const BannerItem: React.FC<BannerItemProps> = ({
  icon,
  title,
  subtitle,
  badge
}) => (
  <div style={flexContainerStyle}>
    <div style={iconWrapperStyle}>{icon}</div>
    <div style={textContainerStyle}>
      <div style={textWithBadgeStyle}>
        <p style={titleStyle}>{title}</p>
        {badge && <span style={badgeStyle}>{badge}</span>}
      </div>
      <span style={subtitleStyle}>{subtitle}</span>
    </div>
  </div>
);

const containerStyle: CSSProperties = {
  ...bannerContainerStyle,
  backgroundColor: '#FFF',
  width: 'calc(100% - 70px)',
  height: '67px'
};

const flexContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center'
};

const iconWrapperStyle: CSSProperties = {
  ...bannerIconWrapperStyle,
  width: '42px',
  height: '42px',
  background: '#EFEFEF',
  position: 'relative'
};

const titleStyle: CSSProperties = {
  margin: 0,
  fontWeight: 'bold',
  fontSize: '14px'
};

const subtitleStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: '400',
  color: '#000'
};

const textWithBadgeStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px' // Reduced gap to bring badge closer to title
};

const badgeStyle: CSSProperties = {
  backgroundColor: '#cbcbcb',
  color: '#FFF',
  fontSize: '9px',
  fontWeight: '600',
  padding: '4px 8px',
  borderRadius: '12px'
};

export default MySpace;
